export default {
	name: 'viewing-as'
}
